import { useViewer } from '@vimeo/viewer';

/**
 * This hook is designed to determine comments visibility and permissions before player module renders.
 * Comments are not shown for users in China.
 * For other users, comments visibility is determined by 2 factors:
 * - whether the user "can interact" (not blocked by the video owner) with the video
 * - whether the comments are enabled in the Page programming
 *
 * This hook is standalone as comments module visibility impacts the page grid layout
 */
export function useCommentsPermissions(canInteract: boolean, comments?: boolean) {
  const viewer = useViewer();

  /**
   * Do not show comments for China users
   */
  if (viewer?.isSimplifiedSite) {
    return { showComments: false };
  }

  /**
   * Whether manage page->Appearance panel->Engagement section->Video Page Only secondary section->Comments toggle is turned on
   */
  const isEngagementCommentsEnabled = Boolean(comments);
  const showComments = isEngagementCommentsEnabled && canInteract;

  return { showComments };
}
